t = require('views/internal/teacup-with-helpers')('boards_page_up_next')

module.exports = t.renderable ({ memberId }) ->

  t.p ->
    t.format 'know-whats-next'

  t.p ->
    t.i ->
      t.format 'youre-one-of-the-few-lucky-people'

  t.a { href: 'https://trello.typeform.com/to/YA7hkz?memberid=' + memberId, target: '_blank' }, ->
    t.format 'let-us-know-what-you-think'

  t.div '.pop-over-section.pop-over-footer', ->
    t.p '.quiet', ->
      t.format 'not-interested'
      t.text ' '
      t.a '.js-disable-up-next', { href: '#' }, ->
        t.format 'disable-this-feature'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/up_next_info.coffee